import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';

function useValidationSchema() {
  const { t } = useTranslation();

  return Yup.object({
    monday: Yup.string().required(t('pages.create_recovery_plan.set_goals.validation.required', { day: t('dates.monday').toLowerCase() })),
    tuesday: Yup.string().required(t('pages.create_recovery_plan.set_goals.validation.required', { day: t('dates.tuesday').toLowerCase() })),
    wednesday: Yup.string().required(t('pages.create_recovery_plan.set_goals.validation.required', { day: t('dates.wednesday').toLowerCase() })),
    thursday: Yup.string().required(t('pages.create_recovery_plan.set_goals.validation.required', { day: t('dates.thursday').toLowerCase() })),
    friday: Yup.string().required(t('pages.create_recovery_plan.set_goals.validation.required', { day: t('dates.friday').toLowerCase() })),
    saturday: Yup.string().required(t('pages.create_recovery_plan.set_goals.validation.required', { day: t('dates.saturday').toLowerCase() })),
    sunday: Yup.string().required(t('pages.create_recovery_plan.set_goals.validation.required', { day: t('dates.sunday').toLowerCase() })),
  }).required();
}

export default useValidationSchema;
